<ng-container *ngIf="!chat">
  <app-chats fxFill (chat)="openMessages($event)"></app-chats>
</ng-container>
<ng-container *ngIf="chat">
  <app-messages
                fxFill
                [chat]="chat"
                (dismiss)="messagesDismiss()"></app-messages>
</ng-container>